import { FC } from 'react';
import { Filters } from 'shared/components/Filters';
import { OffersList } from 'shared/components/OffersList';
import { Section } from 'shared/components/Section';
import {
  AllOffersLinkButtonContainer,
  DealTypeFilterContainer,
  OffersContentContainer,
  OffersIntersectionObserver,
  RoomsTypeFilterContainer,
  DeviceTypeProvider,
} from './containers';

export const OffersListContainer: FC = () => {
  return (
    <Section title="Объявления в этом доме">
      <DeviceTypeProvider>
        <OffersIntersectionObserver>
          <OffersList
            filters={
              <Filters>
                <DealTypeFilterContainer />
                <RoomsTypeFilterContainer />
              </Filters>
            }
            list={<OffersContentContainer />}
            allOffersLinkButton={<AllOffersLinkButtonContainer />}
          />
        </OffersIntersectionObserver>
      </DeviceTypeProvider>
    </Section>
  );
};
